export default function(x) {
  return x;
}



//////////////////
// WEBPACK FOOTER
// D:/glois.angular/~/d3-axis/src/identity.js
// module id = ../../../../d3-axis/src/identity.js
// module chunks = 4